import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { LegalsCloseWrapper } from "./styled";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LectureMediiiaIcon, PrintArtzIcon} from "shared/icons/ArtzIcon";
import {SubmitModalShareButton} from "../ShareModal/styles";
import {LayoutConst, useModal} from "../../../core";
const Wrapper = styled(FlexBox)`
    width: 576px;
    height: 246px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 48px 36px 36px 36px;
    flex-flow: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 142px;
  }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
      letter-spacing: normal;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 16px;
    display: flex;
    flex-flow: column;
    place-items: center;
    flex-direction: row;
  width: 100% ;
  justify-content: center;

    svg {
        transform: scale(1.3);
        cursor: pointer;
        margin-bottom: 1px;
    }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;

    span {
      margin-right: 1px;
    }
    
    svg {
      transform: scale(0.9);
      margin-bottom: 1px;
    }
  }
`;

const Copy = styled(FlexBox)`
    flex-flow: row;
    justify-content: center;
    padding-top: 40px;
    width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;

const CopyInput = styled.div`
    display: flex;
    height: 44px;
    width: 341px;
    background: #F2F2F2;
    border-radius: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    place-items: center;
    padding-left: 16px;
`;

const ErrorCloseWrapper = styled(LegalsCloseWrapper)`
  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 32px;
    right: 32px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
  }
`

export enum SuccessModalTypes {
    ARTZ = 'artz',
    LECTURE_MEDIIIA = 'lecture_mediiia',
}

export const SuccessModal: FC<{ thematicId?: string, cardId?: string, type?: SuccessModalTypes }> = ({ cardId, type = SuccessModalTypes.ARTZ, thematicId }) => {
    const { t } = useTranslation();
    const modal = useModal()

    const artzLink = useMemo(() => (process.env.REACT_APP_URL_ARTZ_SHOP + '/card/' + cardId),[thematicId, cardId]);
    const lectureLink = useMemo(() => (process.env.REACT_APP_URL_EDUCATION_MEDIIIA_RU + '/project/' + cardId),[cardId]);

    const ConfigList: Record<SuccessModalTypes, any> = useMemo(() => ({
        [SuccessModalTypes.ARTZ]: {
            title: t('shop.cards_created'),
            desc: t('shop.cards_created_desc'),
            icon: <PrintArtzIcon />,
            buttonText: t('shop.cards_created_action'),
            onButtonClick: () => window.open(artzLink, "_blank"),
        },
        [SuccessModalTypes.LECTURE_MEDIIIA]: {
            title: t('shop.lecture_media'),
            desc: t('shop.lecture_media_desc'),
            icon: <LectureMediiiaIcon/>,
            buttonText: t('shop.cards_created_action'),
            onButtonClick: () => window.open(lectureLink, "_self"),
        },
    }), [t, artzLink, lectureLink])

    return (
            <Wrapper>
                <ErrorCloseWrapper><IconCloseMob onClick={() => modal.hide()}/></ErrorCloseWrapper>
                <Title>{ConfigList[type]?.title}</Title>
                <Text>
                    <FlexBox>
                        {ConfigList[type]?.desc}
                    </FlexBox>
                    <FlexBox offsetLeft={4} onClick={ConfigList[type]?.onButtonClick}>{ConfigList[type]?.icon}</FlexBox>
                </Text>
                <Copy>
                    <SubmitModalShareButton onClick={ConfigList[type]?.onButtonClick}>
                        {ConfigList[type]?.buttonText}
                    </SubmitModalShareButton>
                </Copy>
            </Wrapper>
    )
}import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { LegalsCloseWrapper } from "./styled";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LectureMediiiaIcon, PrintArtzIcon} from "shared/icons/ArtzIcon";
import {SubmitModalShareButton} from "../ShareModal/styles";
import {LayoutConst, useModal} from "../../../core";
const Wrapper = styled(FlexBox)`
    width: 576px;
    height: 246px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    position: relative;
    padding: 48px 36px 36px 36px;
    flex-flow: column;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 142px;
  }
`;

const Title = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;
  
    @media (max-width: ${LayoutConst.screen.s}px) {
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;
      letter-spacing: normal;
    }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 16px;
    display: flex;
    flex-flow: column;
    place-items: center;
    flex-direction: row;
  width: 100% ;
  justify-content: center;

    svg {
        transform: scale(1.3);
        cursor: pointer;
        margin-bottom: 1px;
    }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;

    span {
      margin-right: 1px;
    }
    
    svg {
      transform: scale(0.9);
      margin-bottom: 1px;
    }
  }
`;

const Copy = styled(FlexBox)`
    flex-flow: row;
    justify-content: center;
    padding-top: 40px;
    width: 100%;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 12px;
  }
`;

const CopyInput = styled.div`
    display: flex;
    height: 44px;
    width: 341px;
    background: #F2F2F2;
    border-radius: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    place-items: center;
    padding-left: 16px;
`;

const ErrorCloseWrapper = styled(LegalsCloseWrapper)`
  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 32px;
    right: 32px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
  }
`

export enum SuccessModalTypes {
    ARTZ = 'artz',
    LECTURE_MEDIIIA = 'lecture_mediiia',
}

export const SuccessModal: FC<{ thematicId?: string, cardId?: string, type?: SuccessModalTypes }> = ({ cardId, type = SuccessModalTypes.ARTZ, thematicId }) => {
    const { t } = useTranslation();
    const modal = useModal()

    const artzLink = useMemo(() => (process.env.REACT_APP_URL_ARTZ_SHOP + '/card/' + cardId),[thematicId, cardId]);
    const lectureLink = useMemo(() => (process.env.REACT_APP_URL_EDUCATION_MEDIIIA_RU + '/project/' + cardId),[cardId]);

    const ConfigList: Record<SuccessModalTypes, any> = useMemo(() => ({
        [SuccessModalTypes.ARTZ]: {
            title: t('shop.cards_created'),
            desc: t('shop.cards_created_desc'),
            icon: <PrintArtzIcon />,
            buttonText: t('shop.cards_created_action'),
            onButtonClick: () => window.open(artzLink, "_blank"),
        },
        [SuccessModalTypes.LECTURE_MEDIIIA]: {
            title: t('shop.lecture_media'),
            desc: t('shop.lecture_media_desc'),
            icon: <LectureMediiiaIcon/>,
            buttonText: t('shop.cards_created_action'),
            onButtonClick: () => window.open(lectureLink, "_self"),
        },
    }), [t, artzLink, lectureLink])

    return (
            <Wrapper>
                <ErrorCloseWrapper><IconCloseMob onClick={() => modal.hide()}/></ErrorCloseWrapper>
                <Title>{ConfigList[type]?.title}</Title>
                <Text>
                    <FlexBox>
                        {ConfigList[type]?.desc}
                    </FlexBox>
                    <FlexBox offsetLeft={4} onClick={ConfigList[type]?.onButtonClick}>{ConfigList[type]?.icon}</FlexBox>
                </Text>
                <Copy>
                    <SubmitModalShareButton onClick={ConfigList[type]?.onButtonClick}>
                        {ConfigList[type]?.buttonText}
                    </SubmitModalShareButton>
                </Copy>
            </Wrapper>
    )
}